export const moveZapsLink = {
    href: '/app/move-zaps/',
    icon: { selected: 'arrowBigRight', unselected: 'arrowBigRight' },
    text: 'Move Zaps',
};
export const settingsLink = {
    href: '/app/settings/profile',
    icon: { selected: 'navCog', unselected: 'navCog' },
    text: 'Settings',
};
export const logOutLink = {
    href: '/logout',
    icon: 'arrowExit',
    text: 'Log Out',
};
export const AccountsMenuLinks = [
    settingsLink,
    logOutLink,
];
export const FALLBACK_TOP_NAV_RESPONSE = {
    topBarMenu: [
        {
            variant: 'product-2',
            heroArea: {
                heading: 'Zapier Automation Platform',
                subheading: 'Bring your entire business under one roof',
                submenu: [
                    {
                        href: null,
                        text: 'PRODUCTS',
                        submenu: [
                            {
                                text: 'Zaps',
                                description: 'Powerful, do-it-yourself automation',
                                href: '/workflows',
                                icon: 'miscBoltAltFill',
                            },
                            {
                                text: 'Tables',
                                description: 'Databases designed for workflows',
                                href: '/tables',
                                icon: 'navTables',
                            },
                            {
                                text: 'Interfaces',
                                description: 'Custom pages to power your workflows',
                                href: '/interfaces',
                                icon: 'navInterfacesV2',
                            },
                        ],
                    },
                    {
                        href: null,
                        text: 'CAPABILITIES',
                        submenu: [
                            {
                                text: 'App integrations',
                                description: 'Explore 6,000 app integrations',
                                href: '/apps',
                            },
                            {
                                text: 'AI features',
                                description: 'Access our latest AI-powered features',
                                href: '/ai',
                            },
                            {
                                text: 'Security',
                                description: 'Enterprise-grade security',
                                href: '/security-compliance',
                            },
                        ],
                    },
                ],
            },
            promoArea: {
                header: {
                    heading: "What's new",
                    href: undefined,
                    subheading: '',
                },
                submenu: [
                    {
                        text: 'Canvas',
                        href: '/canvas',
                        icon: 'navCanvasV2',
                        description: 'Plan and map your workflows with AI',
                        tag: 'Beta',
                    },
                    {
                        text: 'AI Chatbot',
                        href: '/ai/chatbot',
                        icon: 'navChatbots',
                        description: 'Custom no-code chatbots trained on your data',
                        tag: 'Beta',
                    },
                    {
                        text: 'Central',
                        href: '/central',
                        icon: 'navCentral',
                        description: 'Create your own AI bots for any task',
                        tag: 'Preview',
                        tagColor: '#FFBF6E',
                    },
                ],
            },
            text: 'Product',
            bottomLinks: [
                {
                    text: 'Explore templates',
                    icon: {
                        selected: 'actionExplore',
                        unselected: 'actionExplore',
                    },
                    href: '/templates',
                },
                {
                    text: 'Join Zapier Early Access',
                    icon: 'miscBoltAlt',
                    href: '/early-access',
                },
            ],
        },
        {
            text: 'Solutions',
            variant: 'variant-c',
            submenu: [
                {
                    text: 'By use case',
                    href: null,
                    icon: {
                        selected: 'navBriefcase',
                        unselected: 'navBriefcase',
                    },
                    submenu: [
                        {
                            text: 'Lead management',
                            href: '/lead-management',
                        },
                        {
                            text: 'Sales pipeline',
                            href: '/sales-pipeline-management',
                        },
                        {
                            text: 'Marketing campaigns',
                            href: '/marketing-campaigns',
                        },
                        {
                            text: 'Customer support',
                            href: '/customer-support-management',
                        },
                        {
                            text: 'Data management',
                            href: '/data-management',
                        },
                        {
                            text: 'Project management',
                            href: '/project-management',
                        },
                        {
                            text: 'Tickets and incidents',
                            href: '/ticket-incident-management',
                        },
                    ],
                },
                {
                    text: 'By app',
                    href: null,
                    icon: {
                        selected: 'miscList',
                        unselected: 'miscList',
                    },
                    submenu: [
                        {
                            text: 'Salesforce',
                            href: '/apps/salesforce/integrations ',
                        },
                        {
                            text: 'Microsoft Dynamics CRM',
                            href: '/apps/microsoft-dynamics-crm/integrations',
                        },
                        {
                            text: 'HubSpot',
                            href: '/apps/hubspot/integrations',
                        },
                        {
                            text: 'Marketo',
                            href: '/apps/marketo/integrations',
                        },
                        {
                            text: 'Slack',
                            href: '/apps/slack/integrations',
                        },
                        {
                            text: 'Microsoft Teams',
                            href: '/apps/microsoft-teams/integrations',
                        },
                        {
                            text: 'Zendesk',
                            href: '/apps/zendesk/integrations',
                        },
                        {
                            text: 'Jira Software Cloud',
                            href: '/apps/jira-software-cloud/integrations',
                        },
                        {
                            text: 'Jira Service Management',
                            href: '/apps/jira-service-management/integrations',
                        },
                    ],
                },
                {
                    text: 'By team',
                    href: null,
                    icon: {
                        selected: 'personGroup',
                        unselected: 'personGroup',
                    },
                    submenu: [
                        {
                            text: 'Marketing',
                            href: '/solutions/marketing',
                        },
                        {
                            text: 'IT',
                            href: '/solutions/it',
                        },
                        {
                            text: 'Sales',
                            href: '/solutions/sales',
                        },
                        {
                            text: 'RevOps',
                            href: '/solutions/revops',
                        },
                        {
                            text: 'Customer Support',
                            href: '/solutions/customer-support',
                        },
                        {
                            text: 'Leaders',
                            href: '/solutions/leaders',
                        },
                    ],
                },
                {
                    text: 'By company size',
                    href: null,
                    icon: {
                        selected: 'navExplore',
                        unselected: 'navExplore',
                    },
                    submenu: [
                        {
                            text: 'Startups',
                            href: '/solutions/startups',
                        },
                        {
                            text: 'Small and medium businesses',
                            href: '/solutions/smb',
                        },
                        {
                            text: 'Enterprise',
                            href: '/solutions/enterprise',
                        },
                    ],
                },
            ],
            bottomLinks: [
                {
                    text: 'Explore app integrations',
                    icon: {
                        selected: 'actionExplore',
                        unselected: 'actionExplore',
                    },
                    href: '/apps',
                },
                {
                    text: 'Join Zapier Early Access',
                    icon: 'miscBoltAlt',
                    href: '/early-access',
                },
            ],
            promoArea: [
                {
                    type: 'article-stub',
                    text: 'How Zapier Zaps',
                    href: '/l/lead-management-automation-canvas',
                    imageUrl: 'https://res.cloudinary.com/zapier-media/image/upload/q_auto/f_auto/v1695750563/Navigation/Logged%20Out/Frame_12120_ef7x6o.png',
                    description: 'How Zapier’s RevOps team automates lead management',
                    altText: 'Person icon with workflow graphic',
                },
                {
                    type: 'article-stub',
                    text: 'How Zapier Uses AI',
                    href: '/resources/webinar/leaders-using-ai',
                    imageUrl: 'https://res.cloudinary.com/zapier-media/image/upload/q_auto/f_auto/v1695750563/Navigation/Logged%20Out/Mask_group_aprx5j.png',
                    description: 'Using AI & Zapier in Marketing, Sales, & RevOps',
                    altText: 'Graphic that shows webhooks, ChatGPT, and Slack apps connected',
                },
            ],
        },
        {
            text: 'Resources & Support',
            variant: 'variant-b',
            submenu: [
                {
                    text: 'By team',
                    href: null,
                    icon: {
                        selected: 'personGroup',
                        unselected: 'personGroup',
                    },
                    submenu: [
                        {
                            text: 'Marketing',
                            href: '/resources/marketing',
                        },
                        {
                            text: 'Leaders',
                            href: '/resources/leaders',
                        },
                        {
                            text: 'IT',
                            href: '/resources/it',
                        },
                        {
                            text: 'Sales operations',
                            href: '/resources/sales',
                        },
                    ],
                },
                {
                    text: 'Learn more',
                    href: null,
                    icon: {
                        selected: 'miscLearn',
                        unselected: 'miscLearn',
                    },
                    submenu: [
                        {
                            text: 'Blog',
                            href: '/blog/',
                        },
                        {
                            text: 'Zapier Learn',
                            href: 'https://learn.zapier.com',
                        },
                        {
                            text: 'Events and webinars',
                            href: '/resources/events',
                        },
                        {
                            text: 'Customer stories',
                            href: '/customer-stories',
                        },
                        {
                            text: 'Zapier guides',
                            href: '/resources/guides',
                        },
                    ],
                },
                {
                    text: 'Get help',
                    href: null,
                    icon: {
                        selected: 'navHelp',
                        unselected: 'navHelp',
                    },
                    submenu: [
                        {
                            text: 'Help Center',
                            href: 'https://help.zapier.com/hc/en-us',
                        },
                        {
                            text: 'Community',
                            href: 'https://community.zapier.com/',
                        },
                        {
                            text: 'Hire an Expert',
                            href: '/experts',
                        },
                        {
                            text: 'Support Services',
                            href: '/l/support-services',
                        },
                        {
                            text: 'Contact Support',
                            href: '/get-help',
                        },
                    ],
                },
            ],
            bottomLinks: [
                {
                    text: 'Explore app integrations',
                    icon: {
                        selected: 'actionExplore',
                        unselected: 'actionExplore',
                    },
                    href: '/apps',
                },
                {
                    text: 'Join Zapier Early Access',
                    icon: 'miscBoltAlt',
                    href: '/early-access',
                },
            ],
            promoArea: [
                {
                    type: 'article-stub',
                    text: 'Zapier quick-start guide',
                    href: '/learn/zapier-quick-start-guide',
                    imageUrl: 'https://cdn.zapier.com/storage/photos/8d754b5e8481fdd190dd7b1cf7738a8d.png',
                    description: 'Create your first Zap with ease',
                    altText: "A simplified user interface design representing a portion of Zapier's platform. There's a vertical menu of platform options. At the top is a dominant orange button with text inside that reads \"Create Zap.\" Beneath the button is a stack of menu icons to represent Zapier's dashboard and zaps.",
                },
                {
                    type: 'link-list',
                    text: 'Developer resources',
                    href: null,
                    links: [
                        {
                            text: 'Developer Platform',
                            href: '/developer-platform',
                        },
                        {
                            text: 'Build an integration',
                            href: '/developer-platform/integrations',
                        },
                        {
                            text: 'Embed an integration',
                            href: '/developer-platform/embed-tools',
                        },
                        {
                            text: 'Integration Partner Program',
                            href: '/developer-platform/partner-program',
                        },
                        {
                            text: 'Documentation',
                            href: 'https://platform.zapier.com',
                        },
                    ],
                },
            ],
        },
        {
            variant: 'link',
            text: 'Pricing',
            href: '/pricing',
        },
    ],
    callToAction: {
        href: 'https://zapier.com/l/contact-sales',
        text: 'Contact Sales',
    },
    linksInApp: [
        { text: 'Help', icon: 'navHelp', href: 'https://help.zapier.com/hc/en-us' },
        {
            text: 'Explore Zapier',
            icon: 'navExplore',
            href: '/explore',
        },
    ],
};
//# sourceMappingURL=links.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
